import React, { useContext } from "react";
import { MaterialReactTable } from "material-react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { Box, ThemeProvider } from "@mui/material";
import { CSVLink } from "react-csv";
import exportToCsv from "../../../helpers/exportToCsv";
import SikkaTableWrapper from "./SikkaTableWrapper";
import AppContext from "../../../context/Context";

const APIPortalTable = ({
  data,
  columns,
  loading,
  enablePagination,
  enableRowVirtualization,
  CSVFileName,
  onPdfExport,
  enablePdfExport,
  enableRowSelection,
  getRowId, //give each row a more useful id
  onRowSelectionChange, //connect internal row selection state to your own
  state,
  enableSelectAll,
  selectAllMode,
  enableMultiRowSelection,
  enableStickyHeader,
  globalFilterFn,
  muiBottomToolbarProps,
  extraButton,
  layoutMode,
  ...rest
}) => {
  const { isDark } = useContext(AppContext);
  extraButton = extraButton || "";

  muiBottomToolbarProps =
    typeof muiBottomToolbarProps === "object" &&
    !Array.isArray(muiBottomToolbarProps) &&
    Object.values(muiBottomToolbarProps?.sx).length > 0
      ? muiBottomToolbarProps
      : {
          sx: {
            borderBottomRightRadius: "0.395rem",
            borderBottomLeftRadius: "0.395rem",
          },
        };

  return (
    <div>
      <SikkaTableWrapper>
        <MaterialReactTable
          {...rest}
          layoutMode={layoutMode || "grid"}
          enableFilterMatchHighlighting={true}
          globalFilterFn={globalFilterFn || "contains"}
          columns={columns}
          data={data}
          state={{ isLoading: loading, ...state }}
          enableColumnOrdering={false}
          enablePagination={enablePagination}
          initialState={{ density: "compact" }}
          enableRowVirtualization={enableRowVirtualization}
          enableColumnResizing
          renderTopToolbarCustomActions={({ table }) => {
            if (data?.length > 0) {
              let exportObj = {};

              // filter the data according to the sorting and filter state
              if (
                table.getState().showGlobalFilter ||
                table.getState().showColumnFilters
              ) {
                if (table.getState().sorting.length > 0) {
                  exportObj = exportToCsv(
                    table.getSortedRowModel().rows.map((row) => row.original),
                    columns
                  );
                } else {
                  exportObj = exportToCsv(
                    table.getFilteredRowModel().rows.map((row) => row.original),
                    columns
                  );
                }
              } else if (table.getState().sorting.length > 0) {
                exportObj = exportToCsv(
                  table.getSortedRowModel().rows.map((row) => row.original),
                  columns
                );
              } else {
                exportObj = exportToCsv(
                  table.getFilteredRowModel().rows.map((row) => row.original),
                  columns
                );
              }

              return (
                <Box
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    p: "0.5rem",
                    flexWrap: "wrap",
                  }}
                >
                  <CSVLink
                    color="falcon-primary"
                    filename={CSVFileName}
                    style={{
                      color: "#2c7be5",
                      backgroundColor: isDark ? "#132238" : "#fff",
                      borderColor: "#2c7be5",
                      borderWidth: "1px",
                      boxShadow:
                        "0 0 0 1px rgba(43,45,80,0.1), 0 2px 5px 0 rgba(43,45,80,0.08), 0 1px 1.5px 0 rgba(0,0,0,0.07), 0 1px 2px 0 rgba(0,0,0,0.08)",
                      padding: "0.1875rem 0.75rem",
                      fontSize: "0.875rem",
                      borderRadius: "0.2rem",
                      fontWeight: "500",
                      textAlign: "center",
                      verticalAlign: "middle",
                      textDecoration: "none",
                      transition:
                        "color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out",
                    }}
                    data={exportObj.data}
                    headers={exportObj.headers}
                  >
                    <FontAwesomeIcon icon={faDownload} /> .CSV
                  </CSVLink>
                  {enablePdfExport && onPdfExport && (
                    <button
                      onClick={() => onPdfExport(exportObj)}
                      style={{
                        color: "#2c7be5",
                        backgroundColor: isDark ? "#132238" : "#fff",
                        borderColor: "#fff",
                        borderWidth: "1px",
                        boxShadow:
                          "0 0 0 1px rgba(43,45,80,0.1), 0 2px 5px 0 rgba(43,45,80,0.08), 0 1px 1.5px 0 rgba(0,0,0,0.07), 0 1px 2px 0 rgba(0,0,0,0.08)",
                        padding: "0.1875rem 0.75rem",
                        fontSize: "0.875rem",
                        borderRadius: "0.2rem",
                        fontWeight: "500",
                        textAlign: "center",
                        verticalAlign: "middle",
                        textDecoration: "none",
                        transition:
                          "color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out",
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon icon={faFilePdf} /> .PDF
                    </button>
                  )}
                  {extraButton && extraButton}
                </Box>
              );
            }
          }}
          //styling
          muiTableHeadCellProps={{
            //simple styling with the `sx` prop, works just like a style prop in this example
            sx: {
              fontSize: "13px",
              color: isDark ? "#3f91ff" : "#3f91ff",
              backgroundColor: isDark ? "#132238" : "#edf2f97a",
            },
          }}
          muiBottomToolbarProps={muiBottomToolbarProps}
          enableRowSelection={enableRowSelection}
          getRowId={getRowId} //give each row a more useful id
          onRowSelectionChange={onRowSelectionChange} //connect internal row selection state to your own
          selectAllMode={selectAllMode}
          enableSelectAll={enableSelectAll}
          enableMultiRowSelection={enableMultiRowSelection}
          enableStickyHeader={enableStickyHeader}
          muiTablePaperProps={{
            sx: {
              zIndex: "1041 !important",
            },
          }}
        />
      </SikkaTableWrapper>
    </div>
  );
};

export default APIPortalTable;
